import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getDocumentTemplates() {
  const data = await apiGet('helper/documentTemplates/');
  useHelperStore().setDocumentTemplates(data);
}
